import { EditSelectOptions } from './EditSelectOptions'
import EditTooltip from './EditTooltip'
import EditOrientation from './EditOrientation'
import EditLabel from './EditLabel'
import EditFieldType from './EditFieldType'
import EditBoolean from './EditBoolean'
import EditDefaultInput from './EditDefaultInput'
import EditDefaultValue from './EditDefaultValue/EditDefaultValue'
import EditButtonType from './EditButtonType'
import { HeadingType } from './HeadingType'
import EditNameField from './EditNameField'
import EditOptionsSwitch from './EditOptionsSwitch'
import EditMinMaxDate from './EditMinMaxDate'
import EditFormula from './EditFormula'
import { UseFormReturn } from 'react-hook-form'

export type DefaultEditElementProps = {
  element: string
  index: number
  form: UseFormReturn<any>
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function DefaultEditElement(props: DefaultEditElementProps) {
  const { element, index, currentElementState, setCurrentElementState, form } = props
  if (!currentElementState) return null

  if (element === 'children') return
  if (element === 'edit_tabs') return
  if (currentElementState['ui_type'] === 'MAIN_DIV' && element === 'design') return
  if (element === 'ui_type') return
  if (element === 'multiple') return
  if (element === 'element_actions') return
  if (element === 'variant' && currentElementState['ui_type'] === 'BUTTON') return
  if (element === 'rounded' && currentElementState['ui_type'] === 'BUTTON') return
  if (element === 'color' && currentElementState['ui_type'] === 'BUTTON') return
  if (element === 'size' && currentElementState['ui_type'] === 'BUTTON') return
  if (element === 'separator') return

  if (element === 'heading_type') {
    return (
      <HeadingType
        key={index}
        element={element}
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
      />
    )
  }

  if (element === 'select_searchable') {
    return (
      <EditBoolean
        key={index}
        index={index}
        element={element}
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
      />
    )
  }

  if (element === 'select_options') {
    return (
      <EditSelectOptions
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
      />
    )
  }

  if (element === 'disabled') {
    return (
      <EditBoolean
        key={index}
        index={index}
        element={element}
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
      />
    )
  }

  if (element === 'tooltip') {
    return (
      <EditTooltip
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (element === 'orientation') {
    return (
      <EditOrientation
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (
    element === 'label' ||
    element === 'suffix' ||
    (element === 'content' && currentElementState.ui_type === 'BUTTON')
  ) {
    return (
      <EditLabel
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (element === 'form_field_type') {
    return (
      <EditFieldType
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (element === 'type' && currentElementState.ui_type === 'BUTTON') {
    return (
      <EditButtonType
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (element === 'defaultValue') {
    return (
      <EditDefaultValue
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (element === 'name') {
    return (
      <EditNameField
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (element === 'optionsSwitch') {
    return (
      <EditOptionsSwitch
        key={index}
        index={index}
        element={element}
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
      />
    )
  }

  if (element === 'dateValidation') {
    return (
      <EditMinMaxDate
        key={index}
        index={index}
        element={element}
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
      />
    )
  }

  if (element === 'formula') {
    return (
      <EditFormula
        key={index}
        index={index}
        form={form}
        element={element}
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
      />
    )
  }

  return (
    <EditDefaultInput
      currentElementState={currentElementState}
      setCurrentElementState={setCurrentElementState}
      element={element}
      index={index}
    />
  )
}
